import React, { useContext, useState } from "react";

import { Alert, DialogContentText, Snackbar } from "@mui/material";

import { DEFAULT_SNACKBAR_DURATION } from "../../constants";
import ConfirmDialog from "../shared/confirm-dialog";
import { triggerPasswordResetEmail } from "api/endpoints/user";
import { callOptionsHeaders } from "api/helpers";
import { SnackbarContext } from "context/snackbar-context";

interface PasswordResetEmailDialogProps {
  userId: string;
  userEmail: string;
  regionCode: string;
  open: boolean;
  setOpen: (newOpen: boolean) => void;
}

const PasswordResetEmailDialog = ({
  userId,
  userEmail,
  regionCode,
  open,
  setOpen,
}: PasswordResetEmailDialogProps) => {
  const [successOpen, setSuccessOpen] = useState(false);

  const { showError } = useContext(SnackbarContext);

  const handleSendButtonPress = () => {
    triggerPasswordResetEmail(
      { email: userEmail },
      callOptionsHeaders(regionCode, userId)
    )
      .then(() => {
        setSuccessOpen(true);
      })
      .catch(showError);
  };

  return (
    <>
      <ConfirmDialog
        title="Send Password Reset Email"
        open={open}
        cancelBtnLabel="Cancel"
        confirmBtnLabel="Send"
        setOpen={setOpen}
        onConfirm={handleSendButtonPress}
      >
        <DialogContentText>
          A password reset email will be sent to the following email:
          <br />
          {userEmail}
        </DialogContentText>
      </ConfirmDialog>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={successOpen}
        autoHideDuration={DEFAULT_SNACKBAR_DURATION}
        onClose={() => setSuccessOpen(false)}
        data-testid="password-reset-dialog-success"
      >
        <Alert severity="success" variant="filled">
          Successfully sent password reset email
        </Alert>
      </Snackbar>
    </>
  );
};
export default PasswordResetEmailDialog;
